'use client';

import React, { useState } from 'react';
import Login from '@/components/Login';
import Head from 'next/head';
import Footer from '@/components/Footer';
import { PageMetadataUpdater } from '@/hooks/usePageMetadata';

export default function LoginPage() {
  const [user, setUser] = useState(null);

  return (
    <div className="min-h-screen">
      <PageMetadataUpdater pageKey="login" />
      <Login setUser={setUser} />
      <Footer />
    </div>
  );
}